module.exports = __webpack_public_path__ + "img/order-paper-voucher.b15a9839.svg";